import React, { useState, useEffect } from 'react';
import {
  Button,
  Grid,
  Typography,
  Box,
  Card,
  CardContent,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import {
  AccountCircle,
  Email,
  Phone,
  LocationOn,
  Home,
  AssignmentInd,
} from '@mui/icons-material';
import '../../styles/UserStyles.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../styles/AddCustomer.css';
import { useDispatch, useSelector } from 'react-redux';
import { CUSTOMERS } from '../../component/common/Routes/AppRoutes';
import ControlledTextInputField from '../../component/ui/FormFields/ControlledTextInputField';
import CustomButton from '../../component/ui/FormFields/Button';
import {
  addCustomerRequest,
  resetCustomerState,
} from '../../redux/Customers/actions/customerActions';
import {
  selectCityRequest,
  selectCountryRequest,
  selectStateRequest,
} from '../../redux/Common/selectorAction';
import { VENDOR_CUSTOMERS } from '../../component/common/Routes/VendorRoutes';
import { convertDateFormat } from '../../Style';

export default function AddCustomer() {
  const {
    handleSubmit,
    control,
    formState: { errors },
    setError,
    watch,
    setValue,
    clearErrors,
    trigger,
  } = useForm({
    defaultValues: {},
    mode: 'onSubmit',
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // address selector

  useEffect(() => {
    dispatch(resetCustomerState());
    dispatch(selectCountryRequest());
  }, []);

  const formValue = watch();
  const countryId = formValue.country?.value;
  const stateId = formValue.state?.value;
  const passportNumber = watch('passport_number');
  const aadharNumber = watch('aadhar_number');

  // Re-validate when either field changes
  useEffect(() => {
    if (passportNumber || aadharNumber) {
      clearErrors(['passport_number', 'aadhar_number']);
    }
  }, [passportNumber, aadharNumber, clearErrors, trigger]);

  const user = useSelector((state) => state.auth.user);
  const countries = useSelector((state) => state.selector?.country?.data);
  const states = useSelector((state) => state.selector?.state?.data);
  const cities = useSelector((state) => state.selector?.city?.data);
  // country code fetcher
  const countryForCode = countries?.map((value) => {
    return {
      label: ` +${value.phonecode} - ${value.short_name}`,
      value: value.phonecode,
    };
  });
  const countryName = countries?.map((country) => {
    return { value: country?.id, label: country?.country_name };
  });

  const stateName = states?.map((state) => {
    return { value: state?.id, label: state?.state_name };
  });
  const cityName = cities?.map((city) => {
    return { value: city?.id, label: city?.city_name };
  });

  // useEffect runs whenever `country` changes
  useEffect(() => {
    if (countryId > 0) {
      setValue('state', '');
      setValue('city', '');
      dispatch(selectStateRequest(countryId));
    }
  }, [countryId]);
  // change state
  useEffect(() => {
    if (stateId) {
      setValue('city', '');
      dispatch(selectCityRequest(stateId));
    }
  }, [stateId]);

  const success = useSelector((state) => state.customers.success?.add || false);
  const loading = useSelector(
    (state) => state.customers.customerDetails?.loading
  );

  const error = useSelector((state) => state.customers.customerDetails.error);

  // Validation function for passport/aadhar requirement
  const validateIdentityDocument = () => {
    return (
      (passportNumber && passportNumber.trim() !== '') ||
      (aadharNumber && aadharNumber.trim() !== '') ||
      'Either Passport Number or Aadhar Number is required'
    );
  };
  console.log('watach', watch());
  console.log('errors', errors);
  const customerFields = [
    {
      name: 'first_name',
      label: 'First Name (If Company, Enter Company Details) *',
      placeholder: 'Enter First Name',
      icon: <AccountCircle />,
      rules: { required: 'First Name is required' },
      sm: 6,
      xs: 12,
    },
    {
      name: 'last_name',
      label: 'Last Name ',
      placeholder: 'Enter Last Name',
      icon: <AccountCircle />,

      sm: 6,
      xs: 12,
    },
    {
      name: 'email',
      label: 'Email *',
      placeholder: 'Enter Email Address',
      icon: <Email />,
      rules: {
        required: 'Email Address is required',
        pattern: {
          value: /^\S+@\S+\.\S+$/,
          message: 'Enter a valid email address',
        },
      },
      sm: 6,
      xs: 12,
    },

    {
      name: 'dob',
      label: 'Date of Birth (For Companies, Enter a Dummy Date Above Age 12 )*',
      placeholder: 'Select date of birth',
      type: 'dob',
      rules: { required: 'Date of Birth is required' },
      xs: 12,
      sm: 6,
    },
    {
      name: 'country_code',
      options: countryForCode,
      label: 'code *',
      placeholder: 'Select Country Code',
      rules: {
        required: 'Code is Required',
      },
      sm: 2,
      xs: 4,
    },
    {
      name: 'phone',
      label: 'Mobile No *',
      placeholder: 'Enter Mobile Number',
      type: 'Number',
      icon: <Phone />,
      rules: {
        required: 'Mobile Number is required',
        pattern: {
          value: /^\d+$/,
          message: 'Enter only numeric digits',
        },
      },
      sm: 4,
      xs: 8,
    },
    {
      name: 'address1',
      label: 'Address 1 *',
      placeholder: 'Enter Address',
      icon: <Home />,
      rules: { required: 'Address is required' },
      sm: 6,
      xs: 12,
    },
    {
      name: 'address2',
      label: 'Address 2',
      placeholder: 'Enter Address',
      icon: <Home />,
      // rules: { required: "Address is required" },
      sm: 6,
      xs: 12,
    },
    {
      name: 'nationality',
      label: 'Nationality *',
      placeholder: 'Enter Nationality',
      type: 'text',
      rules: {
        required: 'Nationality is required',
        pattern: {
          value: /^[A-Za-z\s]+$/,
          message: 'Only alphabets are allowed',
        },
      },
      xs: 12,
      sm: 6,
      inputProps: {
        onInput: (e) => {
          e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, '');
        },
      },
    },
    {
      name: 'country',
      label: 'Country *',
      placeholder: 'Select Country',
      icon: <LocationOn />,
      rules: { required: 'Country is required' },
      options: countryName,
      sm: 6,
      xs: 12,
    },

    {
      name: 'state',
      label: 'State *',
      placeholder: 'Select State',
      icon: <LocationOn />,
      rules: { required: 'State is required' },
      options: stateName,
      sm: 6,
      xs: 12,
    },
    {
      name: 'city',
      label: 'City *',
      placeholder: 'Select City',
      icon: <LocationOn />,
      rules: { required: 'City is required' },
      options: cityName,
      sm: 6,
      xs: 12,
    },
    {
      name: 'pincode',
      label: 'Pincode *',
      placeholder: 'Enter Pincode',
      icon: <LocationOn />,
      type: 'Number',
      rules: {
        required: 'Pincode is required',
        pattern: {
          value: /^[0-9]+$/,
          message: 'Enter a valid numeric pincode',
        },
      },
      sm: 6,
      xs: 12,
    },
    {
      name: 'passport_number',
      label: 'Passport Number',
      placeholder: 'Enter Passport Number',
      rules: {
        validate: {
          // identityRequired: validateIdentityDocument,
          passportFormat: (value) => {
            if (!value || value.trim() === '') return true;

            const patterns = {
              US: /^[0-9]{9}$/,
              UK: /^[0-9]{9}$|^[A-Z]{2}[0-9]{7}$/,
              EU: /^[A-Z]{1,2}[0-9]{5,7}$/,
              CA: /^[A-Z]{2}[0-9]{6}$/,
              AU: /^[A-Z][0-9]{8}$/,
              IN: /^[A-Z][0-9]{7}$/,
              general: /^[A-Z0-9]{5,12}$/i,
            };

            return (
              patterns.US.test(value) ||
              patterns.UK.test(value) ||
              patterns.EU.test(value) ||
              patterns.CA.test(value) ||
              patterns.AU.test(value) ||
              patterns.IN.test(value) ||
              patterns.general.test(value) ||
              'Please enter a valid passport number'
            );
          },
        },
      },
      xs: 12,
      sm: 6,
    },
    {
      name: 'aadhar_number',
      label: 'Aadhar Number',
      placeholder: 'Enter Aadhar Number',
      type: 'Number',
      rules: {
        validate: {
          // identityRequired: validateIdentityDocument,
          aadharFormat: (value) => {
            if (!value || value.trim() === '') return true;

            return (
              /^\d{12}$/.test(value) ||
              'Aadhar Number must be exactly 12 digits'
            );
          },
        },
      },
      xs: 12,
      sm: 6,
    },
     
  {
  name: 'pan_number',
  label: 'PAN Number',
  type: 'text',
  rules: {
    required: false, // <-- explicitly optional
    validate: (value) => {
      if (value) {
        const validFormat = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value); 
        if (!validFormat) {
          return 'Invalid PAN format (e.g., ABCDE1234F)';
        }
      }
      return true;
    },
  },
  sm: 6,
  xs: 12,
},
{
  name: 'customer_gst_no',
  label: 'GST Number',
  type: 'text',
  rules: {
    required: false, // <-- explicitly optional
    validate: (value) => {
      if (value) {
        const validFormat = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(value);
        if (!validFormat) {
          return 'Invalid GSTIN format (e.g., 22ABCDE1234F1Z5)';
        }
      }
      return true;
    },
  },
  sm: 6,
  xs: 12,
},

    {
      name: 'gender_type',
      label: 'Gender',
      placeholder: 'Select Gender',
      icon: <AssignmentInd />,
      type: 'radio',
      radioOptions: [
        { value: 'M', label: 'Male' },
        { value: 'F', label: 'Female' },
        { value: 'O', label: 'Other' },
      ],
      rules: { required: 'Gender is required' },
      sm: 6,
      xs: 12,
    },
  ];

  useEffect(() => {
    if (success) {
      toast.success('Customer Inserted Successfully!', {
        position: 'top-center',
        autoClose: 3000,
        onClose: () => {
          const redirectRoute =
            user.role === 'Vendor' ? VENDOR_CUSTOMERS : CUSTOMERS;
          navigate(redirectRoute);
          dispatch(resetCustomerState());
        },
      });
    }
    if (error) {
      if (error.message === 'Email must be unique') {
        setError('email', {
          type: 'server',
          message: 'Email must be unique',
        });
      }
      if (error.message === 'Contact must be unique') {
        setError('phone', {
          type: 'server',
          message: 'Contact must be unique',
        });
      }
    }
  }, [success, error, navigate, dispatch, setError]);

  const onSubmit = (data) => {
    clearErrors(); // Clear server-side errors before submitting

    const customerData = {
      first_name: data.first_name,
      last_name: data.last_name,
      display_name: `${data.first_name} ${data.last_name}`,
      email: data.email,
      phone: data.phone,
      country_code: data?.country_code.value,
      address1: data.address1,
      address2: data.address2,
      city: data.city?.value || data.city,
      state: data.state?.value || data.state,
      country: data.country?.value || data.country,
      pincode: data.pincode,
      profile_url: null,
      passport_number: data?.passport_number || null,
      aadhar_number: data?.aadhar_number || null,
      nationality: data?.nationality,
      user_type: '3',
      type: '3',
      dob: convertDateFormat(data.dob),
      gender_type: data?.gender_type,
       customer_gst_no:data?.customer_gst_no||'',
         pan_number:data?.pan_number||'',
    };
    dispatch(addCustomerRequest(customerData));
  };

  return (
    <Box className='container'>
      <Card>
        <CardContent className='card'>
          <Typography variant='h5' className='form-heading'>
            Add Customer
          </Typography>
          <form onSubmit={handleSubmit(onSubmit)} autoComplete='off'>
            <Grid
              container
              rowSpacing={4}
              columnSpacing={{ xs: 1, sm: 1, md: 1, lg: 3 }}
              className='customer-form-margin'
            >
              {customerFields.map((field, index) => (
                <Grid item xs={field.xs} sm={field.sm} key={index}>
                  <ControlledTextInputField
                    name={field.name}
                    control={control}
                    label={field.label}
                    options={field.options}
                    type={field.type}
                    placeholder={field.placeholder}
                    startAdornment={field.icon}
                    radioOptions={field.radioOptions}
                    rules={field.rules}
                    error={!!errors[field.name]}
                    helperText={errors[field.name]?.message}
                  />
                </Grid>
              ))}
              <Grid item xs={12}>
                <Box className='button-container'>
                  <CustomButton
                    variant='contained'
                    className='cancel-button'
                    type='button'
                    text={'Back'}
                    onClick={() => navigate(-1)}
                  />
                  <CustomButton
                    variant='contained'
                    className='success-button'
                    type='submit'
                    loading={loading}
                    text={'Submit'}
                  />
                </Box>
              </Grid>
            </Grid>
          </form>
          <ToastContainer />
        </CardContent>
      </Card>
    </Box>
  );
}
